// useIsPWA.ts
import { useEffect, useState } from 'react'

export function useIsPWA(): { isPWA: boolean } {
  const standaloneQuery = '(display-mode: standalone)'
  const [isPWA, setIsPWA] = useState<boolean>(() => {
    // 初期値は SSR 対応で false
    if (typeof window === 'undefined') return false

    // iOS Safari 専用判定
    if ((window.navigator as any).standalone) return true

    // matchMedia 判定
    return window.matchMedia(standaloneQuery).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined') return

    const mql = window.matchMedia(standaloneQuery)
    const listener = (e: MediaQueryListEvent) => setIsPWA(e.matches)
    // Chrome 106+ は addEventListener 推奨
    // if (mql.addEventListener) {
    //   mql.addEventListener('change', listener);
    //   return () => mql.removeEventListener('change', listener);
    // }
    // // Fallback
    // mql.addListener(listener);
    // return () => mql.removeListener(listener);
  }, [])

  return { isPWA }
}
